import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { SharedModule } from '../shared/shared.module';
import { LessonPageComponent } from './lesson-page/lesson-page.component';
import { MidLevelExamModalComponent } from './mid-level-exam-modal/mid-level-exam-modal.component';
import { ChatBotFabModule } from '../components/chat-bot-fab/chat-bot-fab.component';
import { ChatBotModalModule } from '../components/chat-bot-modal/chat-bot-modal.component';
import { ChatBotNotificationService } from '..//shared/chat-bot-notification.service';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
  imports: [CommonModule, SharedModule, SafeUrlPipeModule, ChatBotModalModule, ChatBotFabModule, UserwaySyncModule],
  declarations: [LessonPageComponent, MidLevelExamModalComponent],
  entryComponents: [MidLevelExamModalComponent],
  providers: [ChatBotNotificationService],
})
export class LearningModule {}



// WEBPACK FOOTER //
// ./ts/app/learning/learning.module.ts